import { useState } from "react";

export default function useCdpBopisModalConnector(selectedStore) {
  const shouldDisplayProductInfoHeader = false;
  const [activeStoreRadioBtn, setActiveStoreRadioBtn] = useState(selectedStore);

  return {
    activeStoreRadioBtn,
    setActiveStoreRadioBtn,
    shouldDisplayProductInfoHeader
  };
}
